import { render, staticRenderFns } from "./vertical-no-menu.vue?vue&type=template&id=69f607e4"
import script from "./vertical-no-menu.vue?vue&type=script&lang=js"
export * from "./vertical-no-menu.vue?vue&type=script&lang=js"
import style0 from "./vertical-no-menu.vue?vue&type=style&index=0&id=69f607e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports